import { render, staticRenderFns } from "./custom-combo.vue?vue&type=template&id=2e61350c"
import script from "./custom-combo.vue?vue&type=script&lang=js"
export * from "./custom-combo.vue?vue&type=script&lang=js"
import style0 from "./custom-combo.vue?vue&type=style&index=0&id=2e61350c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports